var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34425 1.24538C9.24444 1.16757 9.1215 1.12531 8.99494 1.12531C8.86838 1.12531 8.74544 1.16757 8.64563 1.24538L0.5625 7.54819L1.26169 8.43245L2.25 7.66182V14.625C2.25059 14.9232 2.36931 15.209 2.58016 15.4198C2.79101 15.6307 3.07681 15.7494 3.375 15.75H14.625C14.9232 15.7494 15.209 15.6307 15.4198 15.4198C15.6307 15.209 15.7494 14.9232 15.75 14.625V7.66688L16.7383 8.43751L17.4375 7.55326L9.34425 1.24538ZM10.125 14.625H7.875V10.125H10.125V14.625ZM11.25 14.625V10.125C11.25 9.82664 11.1315 9.54049 10.9205 9.32951C10.7095 9.11853 10.4234 9.00001 10.125 9.00001H7.875C7.57663 9.00001 7.29048 9.11853 7.0795 9.32951C6.86853 9.54049 6.75 9.82664 6.75 10.125V14.625H3.375V6.78488L9 2.40301L14.625 6.79051V14.625H11.25Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6884bc5a38e97b83992610f6fa43fada.svg";
export { ForwardRef as ReactComponent };